import React from 'react';
import cn from 'classnames';
import { Typography } from 'antd';
import { ICoupon } from 'mod/coupon/interface';
import { transLocalTime } from 'base/utils/date';
import checkoutRadioStyles from 'app/styles/modules/checkout-radio-style.module.less'
import Iconfont from '@base/lib/Iconfont';
import ThemeCheckBox from '@base/lib/ThemeCheckBox';
import ThemePrice from '@base/lib/ThemePrice';
import { useTrans } from 'base/utils/i18n';

const { Text } = Typography;

type CouponItemProps = {
    isShowNotUseText?: boolean;
    className?: string;
    isShowCopy?: boolean;
    item: ICoupon;
    selected?: ICoupon;
    onSelectCoupon?: (couponCode: string) => void;
};

const CouponItem: React.FC<CouponItemProps> = props => {
    const {
        isShowNotUseText = false,
        isShowCopy = false,
        selected,
        onSelectCoupon,
        item,
    } = props;
    const { t } = useTrans();

    const handleSelectCoupon = (couponCode: string) => {
        typeof onSelectCoupon === 'function' && onSelectCoupon(couponCode);
    };

    return (
        <div key={item.code} className={"item-wrap item-warp-bg"}>
            <div
                key={item.code}
                className={cn(
                    'item',
                    checkoutRadioStyles['checkout-radio'],
                    {
                        disabled: !item.status,
                        pointer: typeof onSelectCoupon === 'function',
                    },
                )}
                role={'button'}
                tabIndex={0}
                onClick={() => handleSelectCoupon(item.code)}
            >
                {/* checkbox */}
                {typeof onSelectCoupon == 'function' && (
                    <div className="checkout-radio-style">
                        <ThemeCheckBox checked={item.code == selected?.code}/>
                        {/*<Checkbox checked={item.code == selected?.code}/>*/}
                    </div>
                )}

                {/* app tag */}
                {!!item.appTag && (
                    <span className='app-tag'>
                        {item.appTag}
                    </span>
                )}

                <div className="info-1">
                    {item.multiStepCouponConfig?.stepConfigs?.length ? (
                        <div className="steps">
                            {item.multiStepCouponConfig.stepConfigs.map(step => (
                                <div className="step" key={step.discount}>
                                    <div className="discount">
                                        {step.discount}
                                    </div>
                                    {!!step.priceLimit && (
                                        <div className="line" dangerouslySetInnerHTML={{ __html: step.priceLimit }}/>
                                    )}
                                </div>
                            ))}
                        </div>
                    ) : (
                        <>
                            <div className="discount">
                                {item.discount}
                            </div>

                            {!!item.priceLimit && (
                                <div className="line" dangerouslySetInnerHTML={{ __html: item.priceLimit }}/>
                            )}
                        </>
                    )}


                    <div className="line">
                        {t('web_coupons_code_label')}:&nbsp;
                        <Text copyable={(typeof onSelectCoupon !== 'function' && isShowCopy)}>
                            {item.code}
                        </Text>
                    </div>

                    {!!item.savePriceText && (
                        <div className="line" dangerouslySetInnerHTML={{ __html: item.savePriceText }}/>
                    )}
                </div>

                <div className="info-2">
                    <div className="line">{transLocalTime(item.startDate)} - {transLocalTime(item.endDate)}</div>
                    <div className="line">{item.productScope}</div>
                </div>
            </div>

            {(!item.status && isShowNotUseText) && (
                <p className="msg"><Iconfont className={'icon-info'}/>{item.couponReason}</p>
            )}
        </div>
    )
};

export default CouponItem;